import React from "react";
import { history } from "../../Healper/history";
import logo from "./logo.jpg";

function Home() {
  const onStartRegistration = () => {
    history.push("/PreRegistration");
  };
  return (
    <div className="card px-2">
      <div className="mx-auto px-2">
        <div
          style={{ marginTop: "10px" }}
          className=" col-md-12 col-sx-12 col-lg-12 col-sm-12"
        >
          <div className="card">
            <div className="card-body">
              <div className="logo">
                <img src={logo} alt="SinaPath" className="logo-img"></img>
              </div>

              <h3>Welcome to Sinapath PCR Actual Time COVID testing page</h3>
              {/* <div>Your health is important for us;</div>
              <div className="row mt-1">
                For requesting the testing service at Sinapath Virology
                laboratory; please take the following short steps;
              </div>
              <div className="row mt-1">
                Click on link below for Scheduling and registering in our
                portal. This will expedite our service and receiving your test
                result, by finalizing your registration you will receive a
                registration barcode. Upon arrival at our sampling location or
                your PCP facility; please show your registration code to test
                sampling coordinator.
              </div>
              <div className="row mt-1">
                We will work on your sample and report the result to your PCP
                upon finalizing the test.
              </div> */}
              <div className="mt-3 col-xs-12 col-sm-6 col-md-2 col-lg-2 offset-md-5 offset-lg-5  offset-sm-3">
                <button
                  className="btn btn-block btn-primary "
                  onClick={onStartRegistration}
                >
                  Registration
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Home;
